import { gql } from '../../../apollo/__generated__';

export const CREATE_BEDROOM_TRANSACTION = gql(`
  mutation CreateBedroomTransaction($createBedroomTransactionInput: CreateBedroomTransactionInput!) {
    createBedroomTransaction(createBedroomTransactionInput: $createBedroomTransactionInput) 
  }
`);
